var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.setRowUnit},model:{value:(_vm.unitValue),callback:function ($$v) {_vm.unitValue=$$v},expression:"unitValue"}},_vm._l((_vm.curUnitList),function(item){return _c('el-option',{key:JSON.stringify(item),attrs:{"label":item.unit,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }